import { styled } from '@mui/material/styles'

export const Divider = styled('div')(() => ({
  height: '1px',
  width: '421px',
  marginTop: '20px',
  marginBottom: '10px',
  background: 'hsla(223, 70%, 92%, 1)',
}))
